import { IsBoolean, IsEmail, IsNumber, IsOptional, IsString } from 'class-validator';

export class LoginDto {
  @IsEmail()
  email!: string;

  @IsString()
  password!: string;
}

export class EmailLoginDto {
  @IsEmail()
  email!: string;
}

export class EmailLoginResponseDto {
  @IsBoolean()
  @IsOptional()
  user?: boolean;

  @IsBoolean()
  @IsOptional()
  userRegistration?: boolean;
}

export class TokenExpireTimestampDto {
  @IsNumber()
  userRegistrationAccessTokenInMs!: number;

  @IsNumber()
  userRegistrationRefreshTokenInMs!: number;
}
